import {
  Input,
  TemplateRef
} from '@angular/core';

/**
 * Card base component
 *
 * For customization, use the templates named headerTemplate and footerTemplate.
 */
export abstract class CardBase {
  /**
   * The name of the template containing footer layout
   */
   footerTemplate: TemplateRef<any>;

  /**
   * The name of the template containing header layout
   */
   headerTemplate: TemplateRef<any>;

  /**
   * The default constructor
   */
  constructor() {
  }
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'footerTemplate': [{ type: Input },],
'headerTemplate': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
